import { Button, Label } from 'components';
import styled from 'styled-components';

export const Container = styled.form``;

export const InputLabel = styled(Label)``;

export const SubmitButton = styled(Button)``;
